import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useCallback } from 'react';
import { nestListeners } from '@atlassian/commerce-events-telemetry-react/core';
import { breadcrumbMountedPayloadToGasV3ScreenEvent, getTelemetryGasV3SharedInfo } from '@atlassian/commerce-events-telemetry-react/gasv3-transformer';
import { getTelemetryMetalMetricInfo } from '@atlassian/commerce-events-telemetry-react/metal-transformer';
import { withSentryExceptionTelemetryInformation } from '@atlassian/commerce-events-telemetry-react/sentry-browser-transformer';
import { createAnalyticsClient, createMonitoringClient, createSentryClient } from '@atlassian/commerce-telemetry-clients';
import { Scope, Severity } from '@atlassian/commerce-telemetry-clients/sentry';
import { Breadcrumb, breadcrumbMountedEventChannel, externalGasV3OperationalEventChannel, externalGasV3ScreenEventChannel, externalGasV3TrackEventChannel, externalGasV3UIEventChannel, externalMetalChannel, externalSentryExceptionChannel, internalGasV3OperationalEventChannel, internalGasV3ScreenEventChannel, internalGasV3TrackEventChannel, internalGasV3UIEventChannel, internalMetalChannel, internalSentryExceptionChannel } from './common/utils/channels';
export { Breadcrumb };
export { catalog } from '@atlassian/commerce-events-telemetry-react/metal-bridge'; // eslint-disable-next-line @atlassian/tangerine/export/no-export-all

import * as _ProbabilityOfBug from './common/utils/probability-of-bug';
export { _ProbabilityOfBug as ProbabilityOfBug };
export { useTaskTracker } from './common/utils/task-tracker';
export { isSuccessfulTaskResult } from './common/utils/task-tracker';
// eslint-disable-next-line @atlassian/tangerine/export/no-export-all
import * as _Service from './common/utils/service';
export { _Service as Service };

var lazyContructor = function lazyContructor(factory) {
  var fabricated;
  return function () {
    if (!fabricated) {
      fabricated = factory();
    }

    return fabricated;
  };
}; // Construct clients lazily to avoid using DOM APIs on import


var getMetalClient = lazyContructor(createMonitoringClient);
var getAnalyticsClient = lazyContructor(createAnalyticsClient);
var getSentryClient = lazyContructor(createSentryClient);

var SinglePackageSafeGuard = function SinglePackageSafeGuard(_ref) {
  var children = _ref.children,
      childPackageListenerModule = _ref.childPackageListenerModule;
  var gasV3UIEventDispatch = externalGasV3UIEventChannel.useEventDispatch();
  var gasV3ScreenEventDispatch = externalGasV3ScreenEventChannel.useEventDispatch();
  var gasV3TrackEventDispatch = externalGasV3TrackEventChannel.useEventDispatch();
  var gasV3OperationalEventDispatch = externalGasV3OperationalEventChannel.useEventDispatch();
  var metalDispatch = externalMetalChannel.useEventDispatch();
  var sentryExceptionDispatch = externalSentryExceptionChannel.useEventDispatch();
  return nestListeners(children, [// Don't bother redispatching if it's the current package and child package listeners are the same component
  childPackageListenerModule.GasV3UIEventListener !== externalGasV3UIEventChannel.Listener ? {
    Listener: childPackageListenerModule.GasV3UIEventListener,
    onEvent: gasV3UIEventDispatch
  } : null, childPackageListenerModule.GasV3ScreenEventListener !== externalGasV3ScreenEventChannel.Listener ? {
    Listener: childPackageListenerModule.GasV3ScreenEventListener,
    onEvent: gasV3ScreenEventDispatch
  } : null, childPackageListenerModule.GasV3TrackEventListener !== externalGasV3TrackEventChannel.Listener ? {
    Listener: childPackageListenerModule.GasV3TrackEventListener,
    onEvent: gasV3TrackEventDispatch
  } : null, childPackageListenerModule.GasV3OperationalEventListener !== externalGasV3UIEventChannel.Listener ? {
    Listener: childPackageListenerModule.GasV3OperationalEventListener,
    onEvent: gasV3OperationalEventDispatch
  } : null, childPackageListenerModule.MetalListener !== externalMetalChannel.Listener ? {
    Listener: childPackageListenerModule.MetalListener,
    onEvent: metalDispatch
  } : null, childPackageListenerModule.SentryExceptionListener !== externalSentryExceptionChannel.Listener ? {
    Listener: childPackageListenerModule.SentryExceptionListener,
    onEvent: sentryExceptionDispatch
  } : null].filter(function (input) {
    return input !== null;
  }));
};

export var ChannelVersionFragmentationSafeGuard = function ChannelVersionFragmentationSafeGuard(_ref2) {
  var childPackageListenerModules = _ref2.childPackageListenerModules,
      children = _ref2.children;
  var wrappedChildren = /*#__PURE__*/React.createElement(React.Fragment, null, children);

  var _iterator = _createForOfIteratorHelper(childPackageListenerModules),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var module = _step.value;
      wrappedChildren = SinglePackageSafeGuard({
        children: wrappedChildren,
        childPackageListenerModule: module
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return wrappedChildren;
};

var getNonDevBreadcrumbs = function getNonDevBreadcrumbs(breadcrumbs) {
  return breadcrumbs.filter(function (breadcrumb) {
    return !breadcrumb.isForDevsOnly;
  });
};

var withCommercePackagesGasV3SharedInfo = function withCommercePackagesGasV3SharedInfo(breadcrumbedPayload) {
  var sharedInfo = getTelemetryGasV3SharedInfo({
    breadcrumbs: getNonDevBreadcrumbs(breadcrumbedPayload.breadcrumbs)
  });
  return _objectSpread(_objectSpread(_objectSpread({}, sharedInfo), breadcrumbedPayload.payload), {}, {
    attributes: _objectSpread(_objectSpread({}, breadcrumbedPayload.payload.attributes), sharedInfo.attributes)
  });
};

var BreadcrumbMountedToScreenTransformer = function BreadcrumbMountedToScreenTransformer(_ref3) {
  var children = _ref3.children;
  var internalGasV3ScreenEventDispatch = internalGasV3ScreenEventChannel.useEventDispatch();
  return /*#__PURE__*/React.createElement(breadcrumbMountedEventChannel.Listener, {
    onEvent: useCallback(function (breadcrumbPayload) {
      if (!breadcrumbPayload.payload.isForDevsOnly) {
        var gasV3ScreenPayload = breadcrumbMountedPayloadToGasV3ScreenEvent(breadcrumbPayload);
        internalGasV3ScreenEventDispatch(gasV3ScreenPayload);
      }
    }, [internalGasV3ScreenEventDispatch])
  }, children);
};

export var InternalCommerceTelemetryIntegrations = function InternalCommerceTelemetryIntegrations(_ref4) {
  var children = _ref4.children;
  var gasV3UIEventDispatch = externalGasV3UIEventChannel.useEventDispatch();
  var gasV3ScreenEventDispatch = externalGasV3ScreenEventChannel.useEventDispatch();
  var gasV3TrackEventDispatch = externalGasV3TrackEventChannel.useEventDispatch();
  var gasV3OperationalEventDispatch = externalGasV3OperationalEventChannel.useEventDispatch();
  var metalDispatch = externalMetalChannel.useEventDispatch();
  var sentryExceptionDispatch = externalSentryExceptionChannel.useEventDispatch();
  var childrenWrappedInScreenTransformer = /*#__PURE__*/React.createElement(BreadcrumbMountedToScreenTransformer, null, children);
  return nestListeners(childrenWrappedInScreenTransformer, [{
    Listener: internalGasV3UIEventChannel.Listener,
    onEvent: useCallback(function (breadcrumbedPayload) {
      var gasV3Payload = withCommercePackagesGasV3SharedInfo(breadcrumbedPayload);
      getAnalyticsClient().sendUIEvent(gasV3Payload);
      gasV3UIEventDispatch(gasV3Payload);
    }, [gasV3UIEventDispatch])
  }, {
    Listener: internalGasV3ScreenEventChannel.Listener,
    onEvent: useCallback(function (payload) {
      getAnalyticsClient().sendScreenEvent(payload);
      gasV3ScreenEventDispatch(payload);
    }, [gasV3ScreenEventDispatch])
  }, {
    Listener: internalGasV3TrackEventChannel.Listener,
    onEvent: useCallback(function (breadcrumbedPayload) {
      var gasV3Payload = withCommercePackagesGasV3SharedInfo(breadcrumbedPayload);
      getAnalyticsClient().sendTrackEvent(gasV3Payload);
      gasV3TrackEventDispatch(gasV3Payload);
    }, [gasV3TrackEventDispatch])
  }, {
    Listener: internalGasV3OperationalEventChannel.Listener,
    onEvent: useCallback(function (breadcrumbedPayload) {
      var gasV3Payload = withCommercePackagesGasV3SharedInfo(breadcrumbedPayload);
      getAnalyticsClient().sendOperationalEvent(gasV3Payload);
      gasV3OperationalEventDispatch(gasV3Payload);
    }, [gasV3OperationalEventDispatch])
  }, {
    Listener: internalMetalChannel.Listener,
    onEvent: useCallback(function (breadcrumbedPayload) {
      var metalPayload = _objectSpread(_objectSpread({}, getTelemetryMetalMetricInfo(breadcrumbedPayload)), breadcrumbedPayload.payload);

      getMetalClient().metric.submit(metalPayload);
      metalDispatch(metalPayload);
    }, [metalDispatch])
  }, {
    Listener: internalSentryExceptionChannel.Listener,
    onEvent: useCallback(function (breadcrumbedPayload) {
      var _scopeContext$tags, _scopeContext$level;

      var payload = withSentryExceptionTelemetryInformation(breadcrumbedPayload);
      var exception = payload.exception,
          hint = payload.hint,
          scopeContext = payload.scopeContext;
      var scope = new Scope(); // TODO: There are alternative ways of doing this. E.g. Using eventFromException. Once decided, we should move it to the Sentry transformers package

      scope.setTags((_scopeContext$tags = scopeContext.tags) !== null && _scopeContext$tags !== void 0 ? _scopeContext$tags : {});

      for (var _i = 0, _Object$entries = Object.entries((_scopeContext$context = scopeContext.contexts) !== null && _scopeContext$context !== void 0 ? _scopeContext$context : {}); _i < _Object$entries.length; _i++) {
        var _scopeContext$context;

        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            context = _Object$entries$_i[1];

        scope.setContext(key, context);
      }

      if (scopeContext.fingerprint !== undefined) {
        scope.setFingerprint(scopeContext.fingerprint);
      }

      scope.setLevel((_scopeContext$level = scopeContext.level) !== null && _scopeContext$level !== void 0 ? _scopeContext$level : Severity.Critical);
      getSentryClient().captureException(exception, hint, scope);
      sentryExceptionDispatch(payload);
    }, [sentryExceptionDispatch])
  }]);
};